<template>
    <div class="login" :class="{gray: active, blur: blur && !$appUtils.isMobile(), lens: $appUtils.isMobile()}">
        <form @submit.prevent.stop="authenticate" class="field-container" @mouseover="blur = true" @mouseout="blur = false">
            <div class="t-c"><img :class="{opacity: active}" src="/assets/images/logo-agrisoy-transparente-3.png" alt="Logo Agrisoy"/></div>
            <div class="label-group" :class="{invalid: getLoginState.length > 0}">
                <input type="email"
                       :class="{filled: !$appUtils.isEmpty(entity.email)}"
                       v-model="entity.email"/>
                <label>E-mail</label>
                <svg-icon icon="user"/>
            </div>
            <div class="label-group" :class="{invalid: getLoginState.length > 0}">
                <input type="password"
                       :class="{filled: !$appUtils.isEmpty(entity.password)}"
                       v-model="entity.password"/>
                <label>Senha</label>
                <svg-icon icon="lock"/>
            </div>
            <div class="error-message">
                <div :class="m.type" v-for="m in getLoginState.messages">{{m.msg}}</div>
            </div>
            <div id="recaptchaContainer" style="display: none; text-align: center">
                <span id="gRecaptcha" class="g-recaptcha" style="display: inline-block;" data-sitekey="6LfIoSIUAAAAAIkh9PQ6gnJx0tmpOyNXJtAhlEDb"></span>
            </div>

            <div class="t-c"><button :class="{rotate: getLoginState.running}" :disabled="getLoginState.running" type="submit">
                <span v-if="!getLoginState.running">ENTRAR</span>
                <span v-else><svg-icon icon="sync"/></span>
            </button></div>

            <div class="forgot-container t-c">
                <br/>
                <br/>
                <router-link to="forgot_password">ESQUECI A SENHA</router-link>
            </div>
        </form>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex'
    const {mapActions, mapGetters} = createNamespacedHelpers('users');

    export default {
        name: "Login",
        data() {
            return {
                entity: {
                    email: '',
                    password: ''
                }
                , active: false
                , blur: false
            }
        },
        methods: {
            authenticate() {
                if (window.grecaptcha) this.entity.g_recaptcha_response = document.getElementById('g-recaptcha-response').value;
                this.login(this.entity);
            },
            ...mapActions(['login', 'releaseState'])
        },
        computed: {
            ...mapGetters(['getLoginState', 'userSession'])
        },
        mounted() {
            if (this.userSession && this.userSession.email) {
                this.entity.email = this.userSession.email;
            }

            setTimeout(() => {
                this.active = true;
            }, 100);

            this.releaseState();
        },
        watch: {
            getLoginState(newVal) {
                const {load_recaptcha} = newVal.length > 0 ? newVal[0] : {};

                if (load_recaptcha) {
                    if (window.grecaptcha) window.grecaptcha.reset();
                    else {
                        document.getElementById('recaptchaContainer').style.display = 'block';
                        (function(i,s,o,g,r,a,m){i['GoogleRecaptchaObject']=r;i[r]=i[r]||function(){
                            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                        })(window,document,'script','https://www.google.com/recaptcha/api.js','grecaptcha');
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/css/modules/session_control";
</style>
